/**
 * Creator video showcase — Portfolio Gallery style lightbox playback
 */
(function () {
  function resetPlayer(player) {
    if (!player) return;
    player.classList.remove('playing', 'ended');
    const video = player.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }

  function resetModal(modal) {
    modal.querySelectorAll('[data-cvs-modal-player]').forEach(resetPlayer);
  }

  function setupModal(modal) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'open' && !modal.hasAttribute('open')) {
          resetModal(modal);
        }
      });
    });
    observer.observe(modal, { attributes: true });
  }

  function bindSection(section) {
    section.querySelectorAll('.creator-video-showcase__video-modal').forEach(setupModal);
  }

  function onDocumentClick(event) {
    const closeButton = event.target.closest('.creator-video-showcase__video-modal .product-media-modal__toggle');
    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();
      const modal = closeButton.closest('modal-dialog');
      if (modal && typeof modal.hide === 'function') {
        modal.hide();
      }
      return;
    }

    const playButton = event.target.closest('.creator-video-showcase__video-modal .portfolio-modal-video-play-button');
    if (playButton) {
      event.preventDefault();
      event.stopPropagation();
      const player = playButton.closest('[data-cvs-modal-player]');
      const video = player?.querySelector('video');
      if (!player || !video) return;

      if (player.classList.contains('ended')) {
        video.currentTime = 0;
      }

      const playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(() => {
            player.classList.remove('ended');
            player.classList.add('playing');
          })
          .catch(() => {
            video.muted = true;
            video.play().catch(() => resetPlayer(player));
          });
      }
      return;
    }

    const player = event.target.closest('.creator-video-showcase__video-modal [data-cvs-modal-player].playing');
    if (player && event.target.closest('video')) {
      const video = player.querySelector('video');
      if (video && !video.paused) {
        event.preventDefault();
        video.pause();
        player.classList.remove('playing');
      }
    }
  }

  function bindVideoEnded() {
    document.querySelectorAll('.creator-video-showcase__video-modal [data-cvs-modal-player] video').forEach((video) => {
      if (video.dataset.cvsEndedBound) return;
      video.dataset.cvsEndedBound = 'true';
      video.addEventListener('ended', () => {
        const player = video.closest('[data-cvs-modal-player]');
        if (!player) return;
        player.classList.remove('playing');
        player.classList.add('ended');
      });
    });
  }

  function init() {
    document.querySelectorAll('.creator-video-showcase').forEach(bindSection);
    bindVideoEnded();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', onDocumentClick);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.creator-video-showcase');
      if (section) {
        bindSection(section);
        bindVideoEnded();
      }
    });
  }
})();
